import gsap from 'gsap';
import LazyLoad from 'vanilla-lazyload';
import EmailsInput from './utils/email-input'
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import Sticky from 'sticky-js';

gsap.registerPlugin(DrawSVGPlugin);
const HTML = document.querySelector('html');

class App {
  constructor() {

		let linksAnchor = document.querySelectorAll('a[href*="#"]:not([href="#"])');
		if( linksAnchor ) linksAnchor.forEach((el) => { el.addEventListener('click', function(e) {
      e.preventDefault();
      const $target = document.querySelector(this.hash)
      if ($target) {
        let pos = $target.getBoundingClientRect();
        if( _.scroll ) {
          _.scroll.scrollTo(pos.top + _.scrollY)
        } else {
          gsap.to(
            document.querySelectorAll('html, body'),
            {
              duration: 0.8,
              scrollTop: window.scrollY + pos.top,
              ease: "expo.out"
            }
          )
        }
      }
    }) });
    
    // Lazyload
    this.lazyload = new LazyLoad({
      // eslint-disable-next-line camelcase
      elements_selector: '.js-lazy',
      threshold: 600,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains('js-lazy-error-placeholder')) {
          $el.lazyLoadPlaceholder = $el.src;
        }
      },
      callback_loaded : (el) => {
        const figure = el.closest('figure');
        if( figure ) figure.classList.add('img-is-loaded')
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    // Anim macaron
    const animMacaron = document.querySelectorAll('[data-anim]');
    if( animMacaron ) {
      animMacaron.forEach(anim => {
        const tl = gsap.timeline({ paused : true, delay : 0.7 });

        tl
          .fromTo(anim.querySelector('.countdown'), { scale : 1 }, { autoAlpha : 1, scale : 1, duration: 2 }, 'start')
          .fromTo(anim.querySelector('.progress'), { drawSVG : '0%' }, { drawSVG : '100%', duration : 2, ease : 'linear.none'}, 'start')
          .to( anim.querySelector('.countdown'), { textContent: 100, duration: 2, snap: { textContent: 1 } }, 'start' )

        tl.play();
      })
    }

    // Anim chiffre
    const animNumbers = document.querySelectorAll('[data-number]');
    if( animNumbers ) {
      animNumbers.forEach(anim => {
        const tl = gsap.timeline({ paused : true, delay : 0.7 });
        const d = 1.3;

        tl
          .to(anim, { autoAlpha : 1, duration : 0.3})
          .from(anim.querySelector('.progress'), { drawSVG : '0%', duration : d, ease : 'linear.none'}, 'start')
          .fromTo( anim.querySelector('.number'), { textContent: 0}, { textContent: anim.dataset.number, duration: d, snap: { textContent: 1 } }, 'start' )

        tl.play();
      })
    }

    this.sticky();

    document.addEventListener('render:view', () => { 
      /*
      const multipleEmails = document.querySelectorAll('.form-multiple-email');
      if( multipleEmails ) {
        multipleEmails.forEach(elt => {
          if( elt.classList.contains('is-init')) return false;
          
          const container = document.createElement('div')
          container.classList.add('form-emails-list');
          elt.append(container);
          elt.classList.add('is-init');
          const orignInput = elt.querySelector('input')
          // orignInput.classList.add('hidden');
          var emailsInput = new EmailsInput(container, {
            placeholder : orignInput.placeholder,
            class : 'form-email-select',
            callback : () => {
              console.log(orignInput)
              console.log('coucou')
              orignInput.value = emailsInput.emails.join(', ')
            }
          });
          emailsInput.render();
        })
      }*/
    })
  }
  sticky() {
    const stickys = document.querySelectorAll('.sticky');

    if( window.innerWidth < 1024 ) return;

    const header = document.querySelector('.main-header')
    const pHeader = header.getBoundingClientRect();
    
    if( stickys ) {
      stickys.forEach(el => {
        const parent = el.parentElement;

        window.addEventListener('scroll', (e) => {
          const pos = el.getBoundingClientRect();
          const pPos = parent.getBoundingClientRect();

          // Now sticky
          if( pPos.top - pHeader.height <= 0 ) {
            el.style.width = `${pPos.width}px`

            if( pPos.bottom - pos.height - pHeader.height <= 0 ) {
              el.style.position = 'absolute'
              el.style.top = `auto`
              el.style.bottom = `0px`
              el.style.left = `0px`
            } else {
              el.style.position = 'fixed'
              el.style.top = `${pHeader.height}px`
              el.style.bottom = `auto`
              el.style.left = `${pPos.x}px`
            }
          } else {
            el.style.position = 'relative'
            el.style.top = `0px`
            el.style.bottom = `auto`
            el.style.left = `0px`
            el.style.width = `100%`
          }
        })
      })
    }
  }

} 

 
window.addEventListener('DOMContentLoaded', () => {
  new App();
})